import React, { useState } from "react";
import { CartsData } from "../../contexts";
import { CartsTable } from "./components";

function Carts() {
    const [data, setData] = useState();

    return (
        <div className="p-7 h-full overflow-y-scroll bg-gray-50">
            <CartsData.Provider value={{ data, setData }}>
                <CartsTable />
            </CartsData.Provider>
        </div>
    );
}

export { Carts };
